import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { PostLaunchTruth } from './components/PostLaunchTruth';
import { InvisibleReaders } from './components/InvisibleReaders';
import { GenericNextSteps } from './components/GenericNextSteps';
import { MechanismVisual } from './components/MechanismVisual';
import { ReaderValue } from './components/ReaderValue';
import { BusinessValue } from './components/BusinessValue';
import { Offer } from './components/Offer';
import { FinishFaqCta } from './components/FinishFaqCta';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { ScoreProvider } from './components/ScoreContext';
export function App() {
  return <ScoreProvider data-id="element-0">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass selection:text-white" data-id="element-1">
        <Nav data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <PostLaunchTruth data-id="element-5" />
          <InvisibleReaders data-id="element-6" />
          <GenericNextSteps data-id="element-7" />
          <MechanismVisual data-id="element-8" />
          <ReaderValue data-id="element-9" />
          <BusinessValue data-id="element-10" />
          <Offer data-id="element-11" />
          <FinishFaqCta data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
        <StickyWidget data-id="element-14" />
      </div>
    </ScoreProvider>;
}